module.exports = __webpack_public_path__ + "3f154de8f7c15bcb327fbca6c6b852a7.png";